import React from 'react';
import { Stack } from 'expo-router';

import { MODAL_SCREEN_OPTIONS } from '../options';

// ─────────────────────────────────────────────────────────────────────────────

export default function ModalsLayout() {
  return <Stack screenOptions={MODAL_SCREEN_OPTIONS} />;
}
